import getGraphQlClient from '~graphql/getGraphQlClient';
import { COUNT_CONVERTED_TEMPLATES } from '~graphql/queries/editorTemplates';

/**
 * Returns the number of Editor_templates with sourceFile populated for the
 * given org. Used to decide between the empty vs populated state of the
 * /start publisher-import box.
 *
 * Errors are swallowed (logged only) and the function resolves to 0 so the
 * empty state renders — the count is ornamental, a failed query must not
 * block the rest of the loader.
 *
 * @param {string} orgId
 * @returns {Promise<number>}
 */
export const fetchConvertedTemplatesCount = async (orgId) => {
  try {
    const graphQlClient = await getGraphQlClient();
    const response = await graphQlClient.query({
      fetchPolicy: 'network-only',
      variables: { orgId },
      query: COUNT_CONVERTED_TEMPLATES,
    });
    return response.data?.findEditorTemplates?.count ?? 0;
  } catch (error) {
    console.error('fetchConvertedTemplatesCount error:', error);
    return 0;
  }
};
